import React, { useEffect, useState } from "react";
import { getUserDataAPI } from "../../service/UserService";
import store from "../../redux/store";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { PERMISSION_MAP } from "../../utils/constants";

export default function Sidebar() {
  const MOBILE_BREAKPOINT = 992;
  const location = useLocation();
  const [userName, setUserName] = useState("");
  const dispatch = useDispatch();
  const userData = store.getState().account.userData;
  const _isMounted = React.useRef(true);
  const getAccountDetails = async () => {
    const { response } = await getUserDataAPI(
      store.getState().account.userData.id
    );
    dispatch({
      type: "accountData/setUserProfile",
      payload: response,
    });
  };
  useEffect(() => {
    _isMounted.current = true;
    return () => {
      _isMounted.current = false;
    };
  }, []);
  useEffect(() => {
    if (_isMounted.current) {
      setUserName(store.getState().account.userData.username);
      const interval = setInterval(() => {
        getAccountDetails();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, []);

  const [isMobileUI, setIsMobileUI] = useState(
    window.innerWidth < MOBILE_BREAKPOINT
  );
  useEffect(() => {
    function handleResize() {
      setIsMobileUI(window.innerWidth < MOBILE_BREAKPOINT);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigate = useNavigate();
  const [currentActive, setCurrentActive] = useState(null);
  const [navs, setNavs] = useState([
    {
      url: "/admin",
      name: "Admin",
      icon: "nav-icon fas fa-address-card",
      enum: "ADMIN",
      isPermissionEnabled: true,
      group: "USER_MANAGEMENT",
    },
    {
      url: "/sub_admin",
      name: "Sub Admin",
      icon: "nav-icon fas fa-address-card",
      enum: "SUB_ADMIN",
      isPermissionEnabled: true,
      group: "USER_MANAGEMENT",
    },
    {
      url: "/master",
      name: "MasterAgent Master",
      icon: "nav-icon fas fa-address-card",
      enum: "MASTER",
      isPermissionEnabled: true,
      group: "USER_MANAGEMENT",
    },
    {
      url: "/super_agent",
      name: "SuperAgent Master",
      icon: "nav-icon fas fa-address-card",
      enum: "SUPER_AGENT",
      isPermissionEnabled: true,
      group: "USER_MANAGEMENT",
    },
    {
      url: "/agent",
      name: "Agent Master",
      icon: "nav-icon fas fa-address-card",
      enum: "AGENT",
      isPermissionEnabled: true,
      group: "USER_MANAGEMENT",
    },
    {
      url: "/client",
      name: "Client Master",
      icon: "nav-icon fas fa-address-card",
      enum: "CLIENT",
      isPermissionEnabled: true,
      group: "USER_MANAGEMENT",
    },
    {
      url: "/game/inPlay",
      name: "InPlay Game",
      icon: "nav-icon fas fa-play",
      group: "GAMES",
    },
    {
      url: "/game/completeGame",
      name: "Complete Game",
      icon: "nav-icon far fa-stop-circle",
      group: "GAMES",
    },
    {
      name: "Live Casino Position",
      url: "#",
      icon: "nav-icon fas fa-chart-line",
      group: "CASINO",
      subNavs: [
        {
          url: "/casino/casino-position/TEEN_20",
          name: "Live Teen20 Position",
          icon: "nav-icon fas fa-chart-bar",
        },
        {
          url: "/casino/casino-position/DRAGON_TIGER_20",
          name: "Live DragonTiger Position",
          icon: "nav-icon fas fa-chart-bar",
        },
        {
          url: "/casino/casino-position/AAA",
          name: "Amar Akbar Anthony Position",
          icon: "nav-icon fas fa-chart-bar",
        },
        {
          url: "/casino/casino-position/LUCKY7",
          name: "Live Lucky7 Position",
          icon: "nav-icon fas fa-chart-bar",
        },
        {
          url: "/casino/casino-position/ABJ",
          name: "Live Andar Bahar Position",
          icon: "nav-icon fas fa-chart-bar",
        },
        {
          url: "/casino/casino-position/DRAGON_TIGER_202",
          name: "Live Dragon Tiger 2 Dashboard",
          icon: "nav-icon fas fa-chart-bar",
        },
        {
          url: "/casino/casino-position/WORLI2",
          name: "Live Worli Dashboard",
          icon: "nav-icon fas fa-chart-bar",
        },
      ],
    }, {
      url: "/casino/casino-details",
      name: "Casino Details",
      icon: "nav-icon fas fa-chart-bar",
      group: "CASINO",
    },
    {
      url: "/casino/casino-bet-report",
      name: "Casino Bet Report",
      icon: "nav-icon fas fa-chart-bar",
      group: "CASINO",
    },
    {
      url: "/ct/client",
      name: "Debit/Credit Entry (C)",
      icon: "nav-icon fas fa-angle-right",
      enum: "CLIENT",
      isPermissionEnabled: true,
      group: "CASH_TRANSACTION",
    },
    {
      url: "/ct/agent",
      name: "Debit/Credit Entry (A)",
      icon: "nav-icon fas fa-angle-right",
      enum: "AGENT",
      isPermissionEnabled: true,
      group: "CASH_TRANSACTION",
    },
    {
      url: "/ct/super_agent",
      name: "Debit/Credit Entry (SA)",
      icon: "nav-icon fas fa-angle-right",
      enum: "SUPER_AGENT",
      isPermissionEnabled: true,
      group: "CASH_TRANSACTION",
    },
    {
      url: "/ct/master",
      name: "Debit/Credit Entry (M)",
      icon: "nav-icon fas fa-angle-right",
      enum: "MASTER",
      isPermissionEnabled: true,
      group: "CASH_TRANSACTION",
    },
    {
      url: "/ct/sub_admin",
      name: "Debit/Credit Entry (SUB)",
      icon: "nav-icon fas fa-angle-right",
      enum: "SUB_ADMIN",
      isPermissionEnabled: true,
      group: "CASH_TRANSACTION",
    },
    {
      url: "/ct/admin",
      name: "Debit/Credit Entry (AD)",
      icon: "nav-icon fas fa-angle-right",
      enum: "ADMIN",
      isPermissionEnabled: true,
      group: "CASH_TRANSACTION",
    },
    {
      url: "/ledger",
      name: "My Ledger",
      icon: "nav-icon fas fa-angle-right",
      group: "LEDGER",
    },
    // {
    //   url: "/ledger/client/pm",
    //   name: "Client Plus/Minus",
    //   icon: "nav-icon fas fa-angle-right",
    //   enum: "CLIENT",
    //   isPermissionEnabled: true,
    //   group: "LEDGER",
    // },
    // {
    //   url: "/ledger/client/pm",
    //   name: "Client Plus/Minus",
    //   icon: "nav-icon fas fa-angle-right",
    //   enum: "CLIENT",
    //   isPermissionEnabled: true,
    //   group: "LEDGER",
    // },
    {
      url: "/ledger/client",
      name: "All Client Ledger",
      icon: "nav-icon fas fa-angle-right",
      enum: "CLIENT",
      isPermissionEnabled: true,
      group: "LEDGER",
    },
    {
      url: "/ledger/agent",
      name: "All Agent Ledger",
      icon: "nav-icon fas fa-angle-right",
      enum: "AGENT",
      isPermissionEnabled: true,
      group: "LEDGER",
    },
    {
      url: "/ledger/super",
      name: "All Super Ledger",
      icon: "nav-icon fas fa-angle-right",
      enum: "SUPER_AGENT",
      isPermissionEnabled: true,
      group: "LEDGER",
    },
    {
      url: "/ledger/master",
      name: "All Master Ledger",
      icon: "nav-icon fas fa-angle-right",
      enum: "MASTER",
      isPermissionEnabled: true,
      group: "LEDGER",
    },
    {
      url: "/ledger/subadmin",
      name: "All Sub Admin Ledger",
      icon: "nav-icon fas fa-angle-right",
      enum: "SUB_ADMIN",
      isPermissionEnabled: true,
      group: "LEDGER",
    },
    {
      url: "/ledger/admin",
      name: "All Admin Ledger",
      icon: "nav-icon fas fa-angle-right",
      enum: "ADMIN",
      isPermissionEnabled: true,
      group: "LEDGER",
    },
    {
      url: `/ledger/commission-lena-dena`,
      name: "कमीशन लेन देन",
      icon: "nav-icon fas fa-angle-right",
      group: "LEDGER"
    },
    {
      name: "Reports",
      url: "#",
      icon: "nav-icon fa fa-book",
      group: "REPORTS",
      subNavs: [
        {
          name: "Current Bets",
          url: "/report/current_bets",
          icon: "nav-icon fa fa-book",
        },
        {
          name: "Bet History",
          url: "/report/bet_history",
          icon: "nav-icon fa fa-book",
        },
        // {
        //   name: "General Report",
        //   url: "/report/general_report",
        //   icon: "nav-icon fa fa-book",
        // },
      ],
    },

    // {
    //   name: "Data Reports",
    //   url: "/data/report",
    //   icon: "nav-icon fas fa-database",
    //   isPermissionEnabled: true,
    //   group: "DATA_REPORTS",
    //   subNavs: [
    //     { url: "/data/report", name: "Admin Reports", enum: "ADMIN" },
    //   ],
    // },
    {
      url: "/data/report",
      name: "Data Reports",
      icon: "nav-icon fas fa-database",
      group: "DATA_REPORTS",
    },
    {
      name: "Login Reports",
      url: "#",
      icon: "nav-icon fas fa-sign-in-alt",
      isPermissionEnabled: true,
      group: "LOGIN_REPORTS",
      subNavs: [
        { url: "/report/login/admin", name: "Admin Login Reports", enum: "ADMIN" },
        { url: "/report/login/sub_admin", name: "Sub Admin Login Reports", enum: "SUB_ADMIN" },
        { url: "/report/login/master", name: "Master Login Reports", enum: "MASTER" },
        { url: "/report/login/super_master", name: "Super Login Reports", enum: "SUPER_AGENT" },
        { url: "/report/login/agent", name: "Agent Login Reports", enum: "AGENT" },
        { url: "/report/login/client", name: "Clients Login Reports", enum: "CLIENT" },
      ],
    },
  ]);


  // Remove all sidebar DOM class toggling from Sidebar. Only Header should control sidebar-open/sidebar-collapse.
  // Sidebar will just render based on those classes present on <body>.
  const closeSideDrawer = () => {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      document.body.classList.remove("sidebar-open");
    }
  };

  const currentUserType = userData?.userType;
  const currentLvl = PERMISSION_MAP[currentUserType];


  const groupedNavs = navs.reduce((acc, item) => {
    if (!acc[item.group]) acc[item.group] = [];
    acc[item.group].push(item);
    return acc;
  }, {});

  const GROUP_LABELS = {
    USER_MANAGEMENT: "User Management",
    GAMES: "Games",
    CASINO: "Casino",
    CASH_TRANSACTION: "Cash Transaction",
    LEDGER: "Ledger",
    REPORTS: "Reports",
    DATA_REPORTS: "Data Reports",
    LOGIN_REPORTS: "Login Reports",
  };



  return (
    <aside className="main-sidebar sidebar-light-indigo elevation-4">
      {/* Brand Logo */}
      <a href="/" className="brand-link bg-indigo text-white">
        <img
          src="https://adminlte.io/themes/v3/dist/img/AdminLTELogo.png"
          alt="AdminLTE Logo"
          className="brand-image img-circle elevation-3"
          style={{ opacity: ".8" }}
        />
        <span className="brand-text font-weight-light" id="brandName">
          1EXCH
        </span>
      </a>
      {/* Removed mobile crossButton toggle, now handled by header only */}
      {/* Sidebar */}
      <div className="sidebar">
        {/* Sidebar Menu */}
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            {Object.entries(groupedNavs).map(([groupName, items]) => {
              if (
                groupName.toUpperCase() === "REPORTS" &&
                userData?.userType?.toUpperCase() !== "SUPER_ADMIN"
              ) {
                return null;
              }
              return (
                <React.Fragment key={groupName}>

                  {/* ===== GROUP HEADER ===== */}
                  <li className="nav-header">
                    {groupName.replace(/_/g, " ")}
                  </li>

                  {/* ===== GROUP ITEMS ===== */}
                  {items.map((item, index) => {
                    const activeKey = `${groupName}-${index}`;

                    if (
                      item?.isPermissionEnabled &&
                      !PERMISSION_MAP[userData?.userType]?.includes(item?.enum) &&
                      !item?.subNavs
                    ) {
                      return null;
                    }

                    return (
                      <li
                        key={activeKey}
                        className={item.active ? "active nav-item" : "nav-item"}
                        onClick={() =>
                          setCurrentActive(
                            currentActive === activeKey ? null : activeKey
                          )
                        }
                      >
                        <a
                          className={
                            location.pathname === item.url
                              ? "active nav-link"
                              : "nav-link"
                          }
                          href="javascript:00"
                          onClick={
                            item.url && !item.subNavs
                              ? () => {
                                navigate(item.url);
                                closeSideDrawer();
                              }
                              : undefined
                          }
                        >
                          <i className={item.icon} />
                          <p>{item.name}</p>

                          {item.subNavs && (
                            <i className="right fas fa-angle-left" />
                          )}
                        </a>

                        {/* ===== SUB NAV ===== */}
                        {item.subNavs && (
                          <ul
                            className={`nav nav-second-level ${currentActive === activeKey ? "" : "collapse"
                              }`}
                          >
                            {item.isPermissionEnabled
                              ? item.subNavs.map(
                                (subnav) =>
                                  PERMISSION_MAP[userData?.userType]?.includes(
                                    subnav.enum
                                  ) && (
                                    <li className="nav-item" key={subnav.name} >
                                      <a
                                        className="nav-link"
                                        href="javascript:00"
                                        onClick={() => {
                                          navigate(
                                            subnav.url,
                                            subnav.state && { state: subnav.state }
                                          );
                                          closeSideDrawer();
                                        }}
                                      >
                                        <i className={subnav.icon} />
                                        {subnav.name}
                                      </a>
                                    </li>
                                  )
                              )
                              : item.subNavs.map((subnav) => (
                                <li className="nav-item" key={subnav.name} >
                                  <a
                                    className="nav-link"
                                    href="javascript:00"
                                    onClick={() => {
                                      navigate(
                                        subnav.url,
                                        subnav.state && { state: subnav.state }
                                      );
                                      closeSideDrawer();
                                    }}
                                  >
                                    <i className={subnav.icon} />
                                    {subnav.name}
                                  </a>
                                </li>
                              ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </React.Fragment>
              );
            })}


          </ul>

          {/* <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {navs.map((item, index) => (
              <li key={index} className={item.active ? "active nav-item" : "nav-item"}
              onClick={() => {
                setCurrentActive(currentActive ? null : index);
              }}>
                <a
                onClick={
                  item.path && !item?.subNavs
                    ? () => {
                        navigate(item.path);
                        closeSideDrawer();
                      }
                    : () => {}
                }
                >
                  <i className={`nav-icon ${item.icon}`} />
                  <p>{item.label}</p>
                  
                  {item?.subNavs && (
                <ul
                  className={`nav nav-second-level ${
                    index == currentActive ? "" : "collapse"
                  }`}
                  id="user_type"
                >
                  {item?.isPermissionEnabled
                    ? item?.subNavs?.map(
                        (subnav) =>
                          PERMISSION_MAP[`${userData?.userType}`]?.includes(
                            subnav.entity
                          ) && (
                            <li>
                              <a
                                onClick={
                                  subnav.url
                                    ? () => {
                                        navigate(
                                          subnav.url,
                                          subnav?.state && {
                                            state: subnav.state,
                                          }
                                        );
                                        closeSideDrawer();
                                      }
                                    : () => {}
                                }
                                data-method="get"
                              >
                                <i className={subnav.icon} />
                                {subnav.label}
                              </a>
                            </li>
                          )
                      )
                    : item?.subNavs?.map((subnav) => (
                        <li>
                          <a
                            onClick={
                              subnav.url
                                ? () => {
                                    navigate(
                                      subnav.url,
                                      subnav?.state && {
                                        state: subnav.state,
                                      }
                                    );
                                    closeSideDrawer();
                                  }
                                : () => {}
                            }
                            data-method="get"
                          >
                            <i className={subnav.icon} />
                            {subnav.label}
                          </a>
                        </li>
                      ))}
                </ul>
              )}
                </a>
              </li>
            ))}
          </ul> */}
        </nav>
        {/* /.sidebar-menu */}
      </div>
      {/* /.sidebar */}
    </aside>
  );
}
